

















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import ScenarioEditComp from "@/components/ScenarioEditComp.vue";
@Component({
  components: {
    ScenarioEditComp,
    Dialog,
    ErrorList
  }
})
export default class ScenarioEdit extends HacoCommon {
  // put something
}
